import { Attributes, LookupBase, NeoModel } from '@singularsystems/neo-core';

@NeoModel
export default class IssuerInvestmentPagedLookup extends LookupBase {

    public issuerInvestmentId: number = 0;

    public entity: string = "";

    public isAuthorised: boolean = false;

    public issuerName: string = "";

    public investmentName: string = "";

    @Attributes.Float()
    public amount: number | null = null;

    @Attributes.Float()
    public utilised: number = 0;

    // Client only properties / methods

    @Attributes.Float()
    public get remaining() {
        return (this.amount ?? 0) - this.utilised;
    }
}